import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { QineticNegotiationApi } from "../../orchestrator-api-client";
import { accertifyDataCollector } from "../../services/accertify-data-collector.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const calculateOffer = createAsyncThunk<void, string, ThunkApi>(
  "calculateOffer",
  async (accertifyUrl, { dispatch, rejectWithValue }) => {
    try {
      const payload = await accertifyDataCollector(accertifyUrl);
      await new QineticNegotiationApi().calculateOffer({
        accertifyData: payload,
      });
    } catch (err: any) {
      pushErrorMonitor(err); //send error push monitor
      const error: LayoutError = {
        title: "Calcolo rata",
        description:
          "Non siamo riusciti a calcolare la rata.\n Puoi riprovare o contattare il supporto",
        isDismissible: false,
        onSubmit: () => dispatch(calculateOffer(accertifyUrl)),
        error: err.message,
      };
      return rejectWithValue(error);
    }
  },
);
